import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Header.css";
import { hasJogoAtivo } from "../../../db/db";
import { useAuth } from "../../../context/AuthContext";
import { signOut } from "firebase/auth";
import { auth } from "../../../service/firebase";

const MENU_ANIMATION_DURATION = 280; // duration must match CSS animation timing

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isClosingMenu, setIsClosingMenu] = useState(false);
  const [jogoAtivo, setJogoAtivo] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();
  const closeTimeoutRef = useRef(null);

  useEffect(() => {
    const verificarJogoAtivo = async () => {
      const ativo = await hasJogoAtivo();
      setJogoAtivo(ativo);
    };
    verificarJogoAtivo();
  }, []);

  const openMenu = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
    setIsClosingMenu(false);
    setIsMenuOpen(true);
  };

  const closeMenu = () => {
    if (!isMenuOpen || isClosingMenu) return;
    setIsClosingMenu(true);
    closeTimeoutRef.current = setTimeout(() => {
      setIsMenuOpen(false);
      setIsClosingMenu(false);
      closeTimeoutRef.current = null;
    }, MENU_ANIMATION_DURATION);
  };

  const toggleMenu = () => {
    if (isMenuOpen && !isClosingMenu) {
      closeMenu();
    } else {
      openMenu();
    }
  };

  useEffect(() => {
    return () => {
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
      }
    };
  }, []);

  // Obter a data de hoje no formato dd/mm/aa
  const today = new Date().toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
  });

  const handleLogout = async () => {
    try {
      closeMenu();
      await signOut(auth);
      navigate("/");
    } catch (error) {
      openMenu();
      console.error("Erro ao sair da conta", error);
    }
  };

  const isMenuVisible = isMenuOpen || isClosingMenu;
  const overlayClasses = ["menu-overlay"];
  const modalClasses = ["menu-modal"];
  if (isClosingMenu) {
    overlayClasses.push("menu-overlay--closing");
    modalClasses.push("menu-modal--closing");
  }

  return (
    <header className="main-header">
      <div className="center">
        <div className="topo">
          <div className="logo">
            <img width="40px" height="40px" src="/images/logo100x100.png" alt="Stop" />
          </div>
          <div className="header-meta">
            <div className="date-to-day">{today}</div>
            <button
              className="btn-menu-sandwich"
              onClick={toggleMenu}
              aria-label="Abrir menu"
              type="button"
            >
              <svg
                width="32px"
                height="32px"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 6H20M4 12H20M4 18H20"
                  stroke="#0b3d2e"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {isMenuVisible && (
        <div className={overlayClasses.join(" ")} onClick={closeMenu}>
          <div
            className={modalClasses.join(" ")}
            role="dialog"
            aria-modal="true"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="menu-header">
              <div>
                <p className="menu-title">Navegação rápida</p>
                {user && (
                  <span className="menu-subtitle">
                    {user.displayName
                      ? `Bem-vindo, ${user.displayName.split(" ")[0]}`
                      : "Logado"}
                  </span>
                )}
              </div>
              <button
                className="menu-close-button"
                onClick={closeMenu}
                aria-label="Fechar menu"
                type="button"
              >
                &times;
              </button>
            </div>
            <div className="menu-options">
              <Link to="/" onClick={closeMenu} className="menu-item">
                Home
              </Link>
              {user && (
                <Link to="/perfil" onClick={closeMenu} className="menu-item">
                  Perfil
                </Link>
              )}
              {user && (
                <Link to="/amigos" onClick={closeMenu} className="menu-item">
                  Amigos
                </Link>
              )}
              <Link to="/turmas" onClick={closeMenu} className="menu-item">
                Turmas
              </Link>
              {!jogoAtivo && (
                <Link to="/novo-amistoso" onClick={closeMenu} className="menu-item">
                  Novo amistoso
                </Link>
              )}
              {user && (
                <button
                type="button"
                onClick={handleLogout}
                className="menu-logout-button"
                >
                  Sair da conta
                </button>
              )}
            </div>
            {jogoAtivo && (
              <div className="menu-live-card">
                <div className="menu-live-info">
                  <span className="live-pulse-dot" aria-hidden="true"></span>
                  <div>
                    <p>Jogo em andamento</p>
                    <small>Continue sua partida atual</small>
                  </div>
                </div>
                <Link
                  to="/novo-amistoso/jogo-em-andamento"
                  onClick={closeMenu}
                  className="menu-live-button"
                >
                  Retomar partida
                </Link>
              </div>
            )}
          </div>
        </div>
      )}
    </header>
  );
};
